<!-- 管理端Login页面 -->
<template>
  <div class="main login-page" v-show="pageReady">
    <div class="split-container">
      <!-- 左侧：品牌展示 (60%) -->
      <div class="left-panel">
        <div class="bg-overlay"></div>
        <div class="bg-gradient"></div>
        
        <div class="brand-content">
          <img src="/weiit_logo.png" class="brand-logo" alt="Weiit Logo" style="height: 48px; margin-bottom: 2rem;" />
          <h1 class="brand-title">
            国内领先的数字化零售SaaS开源方案商
          </h1>
          <p class="brand-desc">
            专为品牌电商、零售打造的数字化增长引擎
          </p>
          
          <div class="brand-stats">
            <div class="avatars">
               <div v-for="i in 4" :key="i" class="avatar-circle"></div>
            </div>
            <p class="stats-text">
              <span class="highlight">5000+</span> 开发者Star
            </p>
          </div>
        </div>
      </div>

      <!-- 右侧：登录面板 (40%) -->
      <div class="right-panel">
        <div class="login-container">
          <div class="login-header">
            <h2 class="welcome-title">欢迎回来</h2>
            <p class="welcome-sub">请选择您喜欢的登录方式</p>
          </div>

          <!-- 翻转容器 -->
          <div class="flip-container">
            <!-- 登录表单 (正面) -->
            <div class="flip-card" :class="{ rotated: rotateY1 }">
              <div class="form-face front">
                 <!-- 切换 Tab -->
                <div class="tab-group">
                  <div
                    class="tab-btn"
                    :class="{ active: item.type == currentTabIndex }"
                    v-for="(item, index) in loginList"
                    :key="index"
                    @click.stop="tabClick(item.type)"
                  >
                    <a-icon :type="item.type == 1 ? 'user' : 'mobile'" class="tab-icon" />
                    {{ item.title }}
                  </div>
                </div>

                <!-- 账号登录表单 -->
                <a-form-model
                  v-if="currentTabIndex == 1"
                  :model="logiInfo"
                  ref="ruleForm"
                  :rules="logiInfoRulesOne"
                  class="login-form"
                  @keyup.enter.native="submit"
                >
                  <a-form-model-item required prop="username" has-feedback>
                    <a-input
                      v-model.trim="logiInfo.username"
                      size="large"
                      autocomplete="off"
                      placeholder="请输入用户名"
                      allow-clear
                      class="custom-input"
                      :class="{ 'shake': shakeMap.username }"
                    >
                      <a-icon slot="prefix" type="user" />
                    </a-input>
                  </a-form-model-item>
                  <a-form-model-item required prop="password" has-feedback>
                    <a-input-password
                      v-model.trim="logiInfo.password"
                      size="large"
                      type="password"
                      autocomplete="off"
                      placeholder="请输入密码"
                      class="custom-input"
                      :class="{ 'shake': shakeMap.password }"
                    >
                      <a-icon slot="prefix" type="lock" />
                    </a-input-password>
                  </a-form-model-item>
                  
                  <div class="captcha-row">
                    <a-form-model-item required prop="captcha" class="flex-1">
                      <a-input
                        v-model.trim="logiInfo.captcha"
                        size="large"
                        type="text"
                        placeholder="验证码"
                        autocomplete="off"
                        allow-clear
                        class="custom-input"
                        :class="{ 'shake': shakeMap.captcha }"
                      >
                        <a-icon slot="prefix" type="qrcode" />
                      </a-input>
                    </a-form-model-item>
                    <div class="captcha-img">
                      <img
                        v-if="randCodeImage"
                        :src="randCodeImage"
                        @click="getVerification"
                      />
                      <img
                        v-else
                        src="../assets/checkcode.png"
                        @click="getVerification"
                      />
                    </div>
                  </div>

                  <div class="form-footer">
                    <a-checkbox v-model="checked">记住密码</a-checkbox>
                    <a class="forgot-link" @click="changeAccount">忘记密码？</a>
                  </div>

                  <!-- 错误信息提示区域 -->
                  <div class="error-message-box" v-if="loginErrorMessage">
                     <a-icon type="close-circle" theme="filled" /> {{ loginErrorMessage }}
                  </div>

                  <a-button
                    size="large"
                    type="primary"
                    htmlType="button"
                    class="submit-btn"
                    :loading="loginBtn"
                    @click.stop.prevent="submit"
                    :disabled="loginBtn"
                  >
                    登录
                    <a-icon type="arrow-right" />
                  </a-button>
                </a-form-model>

                <!-- 短信登录表单 -->
                <a-form-model
                  v-if="currentTabIndex == 2"
                  :model="logiInfoTwo"
                  ref="ruleForm2"
                  :rules="logiInfoRulesTwo"
                  class="login-form"
                  @keyup.enter.native="submit"
                >
                  <a-form-model-item required prop="username" has-feedback>
                    <a-input
                      v-model.trim="logiInfoTwo.username"
                      size="large"
                      :maxLength="11"
                      autocomplete="off"
                      placeholder="请输入手机号"
                      allow-clear
                      class="custom-input"
                      :class="{ 'shake': shakeMap.username }"
                    >
                      <a-icon slot="prefix" type="mobile" />
                    </a-input>
                  </a-form-model-item>
                  
                  <div class="captcha-row">
                     <a-form-model-item required prop="smscode" class="flex-1">
                      <a-input
                        v-model.trim="logiInfoTwo.smscode"
                        size="large"
                        type="text"
                        autocomplete="off"
                        placeholder="验证码"
                        class="custom-input"
                        :class="{ 'shake': shakeMap.smscode }"
                      >
                        <a-icon slot="prefix" type="message" />
                      </a-input>
                    </a-form-model-item>
                    <a-button
                      type="primary"
                      class="get-code-btn"
                      :class="{ opacity: opacity }"
                      v-throttle="() => { handleCode() }"
                    >
                      {{ !opacity ? '获取验证码' : time + '秒' }}
                    </a-button>
                  </div>

                  <div class="form-footer">
                     <div class="spacer"></div>
                     <a class="forgot-link" @click="changeAccount">忘记密码？</a>
                  </div>

                  <!-- 错误信息提示区域 -->
                  <div class="error-message-box" v-if="loginErrorMessage">
                     <a-icon type="close-circle" theme="filled" /> {{ loginErrorMessage }}
                  </div>

                  <a-button
                    size="large"
                    type="primary"
                    htmlType="button"
                    class="submit-btn"
                    :loading="loginBtn"
                    @click.stop.prevent="submit"
                    :disabled="loginBtn"
                  >
                    登录 / 注册
                    <a-icon type="arrow-right" />
                  </a-button>
                </a-form-model>
              </div>

              <!-- 忘记密码表单 (背面) -->
              <div class="form-face back">
                 <div class="login-header small-mb">
                    <h2 class="welcome-title text-center">重置密码</h2>
                 </div>
                 
                 <a-form-model
                  :model="resetModel"
                  ref="ruleForm3"
                  :rules="resetModelRules"
                  class="login-form"
                >
                  <a-form-model-item required prop="phone" has-feedback>
                    <a-input
                      v-model.trim="resetModel.phone"
                      size="large"
                      :maxLength="11"
                      autocomplete="off"
                      placeholder="请输入手机号"
                      allow-clear
                      class="custom-input"
                    >
                      <a-icon slot="prefix" type="mobile" />
                    </a-input>
                  </a-form-model-item>

                  <div class="captcha-row">
                     <a-form-model-item required prop="captcha" class="flex-1">
                      <a-input
                        v-model.trim="resetModel.captcha"
                        size="large"
                        type="text"
                        placeholder="验证码"
                        autocomplete="off"
                        class="custom-input"
                      >
                        <a-icon slot="prefix" type="message" />
                      </a-input>
                    </a-form-model-item>
                    <a-button
                      type="primary"
                      class="get-code-btn"
                      :class="{ opacity: opacity }"
                      v-throttle="() => { handlePassWordCode() }"
                    >
                      {{ !opacity ? '获取验证码' : time + '秒' }}
                    </a-button>
                  </div>

                  <a-form-model-item required prop="newPassword" has-feedback>
                    <a-input
                      v-model.trim="resetModel.newPassword"
                      size="large"
                      type="password"
                      autocomplete="off"
                      placeholder="请输入新密码"
                      allow-clear
                      class="custom-input"
                    >
                      <a-icon slot="prefix" type="lock" />
                    </a-input>
                  </a-form-model-item>

                  <a-button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    class="submit-btn"
                    :loading="loginBtn"
                    @click.stop.prevent="handleResetSubmit"
                    :disabled="loginBtn"
                  >
                    确认修改
                  </a-button>

                  <div class="back-login-link" @click="changeAccount">
                    已有账号？ <a>去登录</a>
                  </div>
                </a-form-model>
              </div>
            </div>
          </div>
          
          <p class="terms-text">
            &copy; <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备18024845号-1</a> 深圳微邦互联科技有限公司 版权所有
          </p>
        </div>
      </div>
    </div>
    <login-model ref="loginModel"></login-model>
  </div>
</template>

<script>
import { getCookie, setCookie, clearCookie } from "../../utils/util.js";
import { Mixin } from "@/view/minxins/minxin";
import loginModel from './module/loginModel'

const FORCE_RELOGIN_FLAG = "__console_force_relogin__";

export default {
  mixins: [Mixin],
  components: {
    loginModel,
  },
  data() {
    return {
      pageReady: false,
      requestCodeSuccess: false,
      randCodeImage: "",
      currdatetime: "",
      time: 60,
      rotateY1: false, // 控制翻转
      opacity: false,
      checked: false,
      shakeMap: {},
      loginErrorMessage: "", // 登录错误提示信息
      loginType: 0,
      logiInfo: {
        username: "",
        password: "",
        inputCode: "",
        captcha: "",
        verificationCode: "", // 兼容原接口参数
        phone: "" // 兼容原接口参数
      },
      logiInfoTwo: {
        username: "",
        smscode: "",
        sendtype: "LG",
      },
      logiInfoRulesOne: {
        username: [{ required: true, message: "请输入账号", trigger: "change" }],
        password: [{ required: true, message: "请输入密码", trigger: "change" }],
        captcha: [{ required: true, message: "请输入图形码", trigger: "change" }],
      },
      logiInfoRulesTwo: {
        username: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: this.handlePhoneCheck, trigger: "change" },
        ],
        smscode: [{ required: true, message: "请输入验证码", trigger: "change" }],
      },
      resetModel: {
        phone: "",
        captcha: "",
        newPassword: "",
      },
      resetModelRules: {
        phone: [{ required: true, message: "请输入手机号！", trigger: "change" }],
        captcha: [{ required: true, message: "请输人验证码！", trigger: "change" }],
        newPassword: [{ required: true, message: "请输入新密码！", trigger: "change" }],
      },
      rememberMe: true,
      loginBtn: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      currentTabIndex: 1,
      loginList: [
        { title: "账号登录", type: 1 },
        { title: "短信登录", type: 2 },
      ],
    };
  },
  provide() {
    return {
      hasPC: this.hasPC
    }
  },
  computed: {
    VUE_APP_LOGO() { return process.env.VUE_APP_LOGO; },
    VUE_APP_NAME() { return process.env.VUE_APP_NAME; },
    VUE_APP_COMPANY_NAME() { return process.env.VUE_APP_COMPANY_NAME; },
    VUE_APP_CAS_YEAR_NAME() { return process.env.VUE_APP_CAS_YEAR_NAME; },
    hasPC() {
      let nav = navigator.userAgent
      let flag = true
      let userAgentArr = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
      for (let i = 0; i < userAgentArr.length; i++) {
        if (nav.includes(userAgentArr[i])) {
          flag = false;
          break;
        }
      }
      return flag
    },
  },
  watch: {
    checked: {
      handler(n, o) {
        if (n !== undefined) {
          localStorage.setItem("checked", n);
        }
      },
      deep: true,
      immedate: true,
    },
  },
  created() {
    this.$nextTick(() => {
      // 登录页保持稳定展示，不再根据本地缓存自动跳转首页。
      sessionStorage.setItem(FORCE_RELOGIN_FLAG, "1");
      this.clearAuthCache();

      this.getChecked();
      this.getUsername();
      this.getVerification();
      // 延迟显示页面以避免闪烁
      setTimeout(() => {
        this.pageReady = true;
      }, 300);
    });
  },
  methods: {
    clearAuthCache() {
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      localStorage.removeItem("userId");
    },
    // 触发抖动效果
    triggerShake(field) {
      this.$set(this.shakeMap, field, true);
      setTimeout(() => {
        this.$set(this.shakeMap, field, false);
      }, 500);
    },
    changeAccount() {
      this.rotateY1 = !this.rotateY1;
      this.opacity = false;
      this.currentTabIndex = 1;
      if (this.currentTabIndex == 1) {
        this.getUsername();
      }
      // Reset logic
      if(this.TimeVariable) clearTimeout(this.TimeVariable);
      this.time = 60;
      if (this.$refs["ruleForm"]) this.$refs["ruleForm"].resetFields();
      if (this.$refs["ruleForm2"]) this.$refs["ruleForm2"].resetFields();
      if (this.$refs["ruleForm3"]) this.$refs["ruleForm3"].resetFields();
    },
    handleResetSubmit() {
      this.$refs["ruleForm3"].validate((res) => {
        if (res) {
          this.loginBtn = true;
          this.$axios
            .post(this.$api.customerForget, this.resetModel)
            .then(({ success, result, message }) => {
              this.loginBtn = false;
              if (success) {
                this.$message.success("修改成功!");
                this.changeAccount(); // Flip back
              } else {
                // this.$message.warn(message); // 拦截器已提示
              }
            })
            .catch(() => {
              this.loginBtn = false;
            });
        }
      });
    },
    submit() {
      if (this.loginBtn) return; // 防止重复点击
      this.loginErrorMessage = ""; // 清空错误信息

      const self = this;
      let url = "";
      let type;
      let res;
      if (this.currentTabIndex == 1) {
        type = "ruleForm";
        res = this.logiInfo;
        url = this.$api.login;
      } else {
        type = "ruleForm2";
        res = this.logiInfoTwo;
        url = this.$api.phoneLogin;
        res.sendtype = "LG";
      }
      this.$nextTick(() => {
        this.$refs[type].validate((valid, object) => {
          if (valid) {
            if (this.currentTabIndex == 1) {
               if (this.logiInfo.captcha.length < 4) {
                  // this.$message.warning("请输入4位验证码"); // Removed toast
                  this.triggerShake('captcha');
                  return;
               }
              }
            if (this.checked && this.currentTabIndex == 1) {
              setCookie(res.username, res.password, 7);
            } else {
              clearCookie();
            }
            
            // 合并 checkKey
            let data = Object.assign(res, {
              checkKey: this.currdatetime,
            });

            this.loginBtn = true;
            this.$axios
              .post(url, res)
              .then(({ success, result, message }) => {
                if (success) {
                  this.$message.success("登录成功!");
                  localStorage.setItem("token", result.token);
                  
                  // 修复 userName 获取逻辑 (Platform返回的是 customerName 和 customerPhone)
                  let user = result.userInfo;
                  let userNameStr = '管理员';
                  if (user) {
                      userNameStr = user.customerName || user.customerPhone || user.realname || user.username || '管理员';
                  }
                  localStorage.setItem("userName", userNameStr);
                  
                  if (user && user.id) {
                      localStorage.setItem("userId", user.id);
                  } else {
                      localStorage.setItem("userId", result.userId); // 兼容旧逻辑
                  }
                  
                  // 优先执行业务跳转逻辑 (商城/门店)
                  this.initData(() => {
                    // 读取环境变量中的自动跳转开关（默认为 true）
                    const autoRedirect = process.env.VUE_APP_AUTO_REDIRECT !== 'false';
                    
                    if (autoRedirect) {
                        // 开启了自动跳转，且有明确的单一业务权限，则直达
                        if (this.hasStore && !this.hasMall) this.active = 1;
                        else if (this.hasMall && !this.hasStore) this.active = 2;
                    }

                    if (this.active > 0) {
                      this.toGo();
                    } else if (process.env.VUE_APP_HOME_BASE_URL) {
                      // 兜底或强制跳转到主页
                      location.href = `${process.env.VUE_APP_HOME_BASE_URL}?token=${encodeURIComponent(result.token)}`;
                    }
                  });
                } else {
                  this.loginBtn = false;
                  // 接口返回错误时，通常是密码或验证码错误，给予视觉反馈
                  this.triggerShake('password'); 
                  this.triggerShake('captcha');
                  this.triggerShake('smscode');
                  
                  // 设置行内错误信息
                  this.loginErrorMessage = message || "登录失败，请检查账号密码";

                  if (this.currentTabIndex == 1) {
                     this.getVerification();
                  }
                }
              })
              .catch((err) => {
                console.error("【Login Debug】请求异常:", err);
                this.loginBtn = false;
                this.loginErrorMessage = "网络或服务器异常，请稍后重试";
                if (this.currentTabIndex == 1) {
                   this.getVerification();
                }
              });
          } else {
            // 表单验证失败，自动聚焦第一个错误项并抖动
            if (object) {
                // 定义校验顺序优先级
                const priority = ['username', 'password', 'captcha', 'smscode'];
                // 找到第一个错误的字段
                const firstErrorField = priority.find(field => object[field]);
                
                if (firstErrorField) {
                  this.triggerShake(firstErrorField);
                  this.$nextTick(() => {
                    // 尝试找到对应的输入框并聚焦
                    // 我们假设输入框在 .has-error 下，但这需要遍历
                    // 更好的方式是直接根据 ref 或 class
                    const errorItem = this.$el.querySelector(`.custom-input.shake input`) || 
                                    this.$el.querySelector(`.has-error input`);
                    if (errorItem) {
                      errorItem.focus();
                    }
                  });
                }
              }
              return false;
            }
        });
      });
    },
    getVerification() {
      this.currdatetime = new Date().getTime();
      console.log('Fetching captcha with key:', this.currdatetime);
      this.$axios
        .get(`${this.$api.randomImage}/${this.currdatetime}`)
        .then((res) => {
          console.log('Captcha response:', res);
          const { success, result, message } = res;
          if (success) {
            this.randCodeImage = result;
            console.log('Captcha image set:', this.randCodeImage ? this.randCodeImage.substring(0, 50) + '...' : 'null');
          } else {
            this.$message.error(message);
            console.error('Captcha failed:', message);
          }
        })
        .catch(err => {
            console.error('Captcha error:', err);
        });
    },
    getChecked() {
      let checked = localStorage.getItem("checked");
      if (checked == "true") {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    getUsername() {
      let { username, password } = getCookie();
      // 增加对 "undefined"、"null" 字符串和 [object Object] 的过滤
      const isValid = (val) => val && val !== "undefined" && val !== "null" && val !== "[object Object]";
      
      if (isValid(username)) {
        this.logiInfo.username = username;
        if (isValid(password)) {
          this.logiInfo.password = password;
        }
        this.checked = true; 
      }
    },
    handlePhoneCheck(rule, value, callback) {
      if (!value) {
        // Empty message to avoid default toast
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    },
    handleTime() {
      this.opacity = true;
      this.TimeVariable = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.TimeVariable);
          this.opacity = false;
          this.time = 60;
        }
      }, 1000);
    },
    handleCode() {
      if (this.opacity) return;
      this.$refs["ruleForm2"].validateField("username", (err) => {
        if (!err) {
          let data = {
            customerPhone: this.logiInfoTwo.username,
            sendType: "LG",
          };
          this.$axios
            .post(this.$api.randomPhoneCode, data)
            .then(({ success, result, message }) => {
              if (success) {
                this.handleTime();
                this.$message.success("验证码发送成功!");
              } else {
                this.$message.error(message || "验证码发送失败");
              }
            })
            .catch((err) => {
              this.$message.error("验证码发送异常，请稍后重试");
            });
        }
      });
    },
    handlePassWordCode() {
      if (this.opacity) return;
      this.$refs["ruleForm3"].validateField("phone", (err) => {
        if (!err) {
          let data = {
            customerPhone: this.resetModel.phone,
            sendType: "WJ",
          };
          this.$axios
            .post(this.$api.randomPhoneCode, data)
            .then(({ success, result, message }) => {
              if (success) {
                this.handleTime();
                this.$message.success("验证码发送成功!");
              } else {
                this.$message.error(message || "验证码发送失败");
              }
            })
            .catch((err) => {
              this.$message.error("验证码发送异常，请稍后重试");
            });
        }
      });
    },
    tabClick(index) {
        this.currentTabIndex = index;
        this.loginErrorMessage = "";
        this.shakeMap = {};
        
        // 重置表单数据
        this.logiInfo = {
            username: "",
            password: "",
            inputCode: "",
            captcha: "",
            verificationCode: "",
            phone: ""
        };
        this.logiInfoTwo = {
            username: "",
            smscode: "",
            sendtype: "LG"
        };
        
        // 如果是账号登录，尝试恢复记住的账号并刷新验证码
        if (index == 1) {
            this.getUsername();
            this.getVerification();
        }
    },
  }
};
</script>

<style lang="less" scoped>
@import './error-style.less';

@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}

.shake {
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  border-color: #ff4d4f !important;
}

.login-page {
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow: hidden;
}

.split-container {
  display: flex;
  width: 100%;
  height: 100%;
}

/* Left Panel */
.left-panel {
  display: none;
  width: 60%;
  position: relative;
  background-color: #111827; // gray-900
  overflow: hidden;
  align-items: center;
  justify-content: center;

  @media (min-width: 1024px) {
    display: flex;
  }

  .bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop');
    background-size: cover;
    background-position: center;
    opacity: 0.4;
    mix-blend-mode: overlay;
  }

  .bg-gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(49,46,129,0.9), rgba(88,28,135,0.8), rgba(0,0,0,0.9));
  }

  .brand-content {
    position: relative;
    z-index: 10;
    max-width: 600px;
    padding: 0 48px;
    color: white;
  }

  .logo-box {
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, #6366f1, #7c3aed);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
    box-shadow: 0 25px 50px -12px rgba(124, 58, 237, 0.3);

    .logo-icon {
      font-size: 32px;
      color: white;
    }
  }

  .brand-title {
    font-size: 48px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 24px;
    color: white;
  }

  .brand-desc {
    font-size: 20px;
    color: #d1d5db; // gray-300
    font-weight: 300;
    margin-bottom: 48px;
    line-height: 1.5;
  }

  .brand-stats {
    display: flex;
    gap: 16px;
    align-items: center;

    .avatars {
      display: flex;
      margin-left: 10px;
      .avatar-circle {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid #312e81;
        background-color: #4b5563;
        margin-left: -12px;
        &:first-child { margin-left: 0; }
      }
    }

    .stats-text {
      font-size: 14px;
      color: #9ca3af;
      .highlight {
        color: white;
        font-weight: 700;
        margin-right: 4px;
      }
    }
  }
}

/* Right Panel */
.right-panel {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: white;
  position: relative;

  @media (min-width: 1024px) {
    width: 40%;
  }
}

.login-container {
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;

  &.small-mb {
    margin-bottom: 20px;
  }

  .welcome-title {
    font-size: 24px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 8px;
  }

  .welcome-sub {
    font-size: 14px;
    color: #6b7280;
  }
}

/* Tabs */
.tab-group {
  display: flex;
  padding: 4px;
  background: #f3f4f6;
  border-radius: 12px;
  margin-bottom: 32px;
}

.tab-btn {
  flex: 1;
  padding: 10px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    color: #374151;
  }

  &.active {
    background: white;
    color: #111827;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  }

  .tab-icon {
    font-size: 14px;
  }
}

/* Form Styles */
.custom-input {
  /deep/ .ant-input {
    height: 44px;
    border-radius: 12px;
    border-color: #e5e7eb;
    background: #f9fafb;
    padding-left: 40px !important; // Make room for icon if needed, though prefix handles it
    
    &:hover, &:focus {
      border-color: #6366f1;
      box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
      background: white;
    }
  }

  /deep/ .ant-input-prefix {
    color: #9ca3af;
  }
}

.captcha-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;

  .flex-1 {
    flex: 1;
  }

  .captcha-img {
    height: 44px;
    cursor: pointer;
    img {
      height: 100%;
      border-radius: 8px;
    }
  }

  .get-code-btn {
    height: 44px;
    border-radius: 12px;
    background: #f3f4f6;
    color: #4b5563;
    border: none;
    font-weight: 500;
    padding: 0 20px;
    
    &:hover {
      background: #e5e7eb;
      color: #111827;
    }
  }
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.forgot-link {
  color: #6366f1;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.submit-btn {
  width: 100%;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(to right, #4f46e5, #7c3aed);
  border: none;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.2);

  &:hover, &:focus {
    background: linear-gradient(to right, #4338ca, #6d28d9);
    transform: translateY(-1px);
    box-shadow: 0 10px 15px -3px rgba(79, 70, 229, 0.3);
  }
}

.terms-text {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin-top: 32px;
  
  a {
    color: #111827;
    &:hover { text-decoration: underline; }
  }
}

/* Flip Animation Logic */
.flip-container {
  perspective: 1000px;
  position: relative;
  min-height: 400px; // Ensure height for absolute positioning
}

.flip-card {
  position: relative;
  width: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card.rotated {
  transform: rotateY(180deg);
}

.form-face {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  top: 0;
  left: 0;
  background: white;
}

.form-face.back {
  transform: rotateY(180deg);
}

.back-login-link {
  text-align: center;
  margin-top: 16px;
  color: #6b7280;
  cursor: pointer;
  
  a {
    color: #6366f1;
    font-weight: 500;
  }
}

/* Spacer */
.spacer {
  flex: 1;
}

.text-center {
  text-align: center;
}
</style>
